import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});


const getSingleTrainerStats = createSlice({
    name: 'singletrainerstats',
    initialState: {
        data: [],
        totalcount: 0,
        totalPages: 0,
        currentPage: 1,
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchSingleTrainerStats.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchSingleTrainerStats.fulfilled, (state, action) => {
                if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
                    state.data = action.payload.data || [];
                    state.totalcount = action.payload.totalcount || 0;
                    state.totalPages = action.payload.totalPages || 0;
                    state.currentPage = action.payload.currentPage || 1;
                } else {
                    state.data = Array.isArray(action.payload) ? action.payload : [];
                    state.totalcount = state.data.length;
                    state.totalPages = Math.ceil(state.data.length / 10);
                    state.currentPage = 1;
                }
                state.status = STATUSES.IDLE;
            })
            .addCase(fetchSingleTrainerStats.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            });
    }
});

export const { setTrainer, setStatus } = getSingleTrainerStats.actions;
export default getSingleTrainerStats.reducer;

export const fetchSingleTrainerStats = createAsyncThunk(
    '/LatestResultOfHorsesWithTrainer/fetch',
    async ({ year = "", id, page = 1, size = 10 } = {}) => {
        const cleanYear = year === undefined || year === null ? "" : year;
        const res = await axios.get(
            `${getBaseUrl()}/LatestResultOfHorsesWithTrainer/${id}?year=${cleanYear}&page=${page}&size=${size}`
        );
        return res.data;
    }
);
